import React from 'react';
import { ArrowRight, Download, Smartphone, TrendingUp, AlertCircle } from 'lucide-react';
import { PaymentIcons } from './PaymentIcons';
export function FinalCTASection() {
  return <section id="cta-section" className="w-full bg-gradient-to-b from-white to-teal-50 py-16 px-4" data-id="element-15">
      <div className="max-w-xl mx-auto text-center" data-id="element-16">
        <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-17">
          Exclusive launch
        </h2>
        <div className="bg-gray-200 rounded-full py-2 px-6 inline-block mb-4" data-id="element-18">
          <p className="text-gray-800 font-semibold" data-id="element-19">
            Only 85 copies available
          </p>
        </div>
        <p className="text-lg text-gray-700 mb-10" data-id="element-20">
          For a limited time, you can access Eat To Heal for a fraction of its
          real value.
        </p>
        <div className="bg-white rounded-lg shadow-xl overflow-hidden mb-8" data-id="element-21">
          {/* Header dark section */}
          <div className="bg-teal-800 text-white py-6 px-4" data-id="element-22">
            <h3 className="text-2xl font-bold mb-2" data-id="element-23">EAT TO HEAL</h3>
            <p className="text-teal-100" data-id="element-24">Complete system access</p>
          </div>
          {/* Product image */}
          <div className="p-4 bg-white" data-id="element-25">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pUz2ycH78DhCGCtiWuR8CA/ChatGPT_Image_27_sept_2025%2C_23_41_42.webp" alt="Eat To Heal Recipe eBook" className="w-full h-auto rounded-lg" data-id="element-26" />
          </div>
          {/* Reorganizado según la imagen compartida */}
          <div className="px-8 py-4" data-id="element-27">
            {/* Price section */}
            <div className="flex justify-center items-center mb-6" data-id="element-28">
              <span className="text-gray-500 line-through text-xl" data-id="element-29">
                $39 USD
              </span>
              <span className="text-4xl font-bold text-gray-900 ml-4" data-id="element-30">
                $19 USD
              </span>
            </div>
            {/* Limited time offer notice */}
            <div className="bg-gray-100 py-4 px-6 border-l-4 border-gray-400 flex items-start mb-6 rounded" data-id="element-31">
              <AlertCircle size={20} className="text-gray-600 mr-2 flex-shrink-0 mt-1" data-id="element-32" />
              <p className="text-gray-700 text-left text-sm" data-id="element-33">
                <span className="font-semibold" data-id="element-34">Limited time offer!</span> After
                200 copies sold, the price will return to $39 USD
              </p>
            </div>
            {/* Benefits */}
            <div className="mb-6" data-id="element-35">
              <div className="flex items-center py-3" data-id="element-36">
                <Download size={20} className="text-gray-700 mr-3" data-id="element-37" />
                <p className="text-gray-800" data-id="element-38">Immediate download</p>
              </div>
              <div className="flex items-center py-3" data-id="element-39">
                <Smartphone size={20} className="text-gray-700 mr-3" data-id="element-40" />
                <p className="text-gray-800" data-id="element-41">Access from any device</p>
              </div>
              <div className="flex items-center py-3" data-id="element-42">
                <TrendingUp size={20} className="text-gray-700 mr-3" data-id="element-43" />
                <p className="text-gray-800" data-id="element-44">Improvement from the first week</p>
              </div>
            </div>
            {/* FREE BONUSES Banner */}
            <div className="bg-teal-50 py-3 px-4 mb-6 border-l-4 border-teal-600 rounded" data-id="element-45">
              <p className="text-teal-700 font-bold" data-id="element-46">Includes 2 FREE BONUSES</p>
            </div>
            {/* CTA Button */}
            <a href="https://ebooksociety.co/cart/51407721562393:1?checkout" className="w-full bg-orange-600 hover:bg-orange-700 text-white font-bold py-4 px-6 rounded-lg text-xl transition inline-block text-center shadow-lg mb-4" data-id="element-47">
              Download Eat To Heal Now
            </a>
            {/* Payment Icons */}
            <PaymentIcons data-id="element-48" />
            {/* Final note */}
            <p className="text-gray-500 text-sm text-center mt-4 mb-2" data-id="element-49">
              One-time payment. No subscriptions or hidden charges.
            </p>
          </div>
        </div>
      </div>
    </section>;
}